<template>
    <RoundButton
        icon="discord"
        interfaceTarget="discord-button"
        :externalTo="DISCORD_URL"
        target="_blank"
    />
</template>

<script setup lang="ts">
import { DISCORD_URL } from '../constants'
import RoundButton from './RoundButton.vue'
</script>
